import { api } from './_client';

export const llmApi = {
  // Check LLM service health
  async llmHealthCheck(): Promise<{
    status: string;
    llm_provider: string;
    api_key_configured: boolean;
  }> {
    const response = await api.get('/api/llm/health');
    return response.data;
  },

  // Reset conversation session
  async resetSession(sessionId: string): Promise<{
    success: boolean;
    message: string;
  }> {
    const response = await api.post('/api/llm/reset-session', {
      session_id: sessionId,
    });
    return response.data;
  },

  // List available agents for manual selection
  async listAvailableAgents(): Promise<{
    agents: Array<{
      name: string;
      description: string;
      capabilities: string[];
    }>;
  }> {
    const response = await api.get('/api/llm/agents');
    return response.data;
  },
};
